<template>
  <div>
    <config-main-title v-if="!setup">Clínica
      <template v-slot:right>
        <h5 v-if="$store.state.user.lics > 0">
          <span class="badge badge-dark">
            Total de Licenças: {{ $store.state.user.lics }}
          </span>
        </h5>
      </template>
    </config-main-title>

    <div v-if="!dados">
      <az-empty-state></az-empty-state>
    </div>

    <div v-if="dados && !item">

      <div class="list-group mb-3 w3-animate-opacity mb-3">
        <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
          <span>
              <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                  {{ dado.search }}
              </a>
          </span>
          <span class="d-flex" v-if="1 == 0">
              <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" :id="'ativo-' + id" 
                      v-model="dado.fl_ativo" 
                      @change="toggle_procedimento(dado)">
                  <label class="custom-control-label" :for="'ativo-' + id"></label>
              </div>
          </span>
        </li>
      </div>

    </div>
    
    <div class="card mb-5 w3-animate-opacity" v-if="item">
      <div class="card-header bg-success text-white" v-if="!item.id_unidade">
        <span class="lead">Nova Unidade</span>
      </div>
      <div class="card-header" v-else>
        <span class="lead text-primary">Dados Básicos</span>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col col-12 col-md-6">
            <div class="mb-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <input
                      type="radio"
                      aria-label="Radio button for following text input"
                      value="J"
                      v-model="item.natureza"
                    />
                  </div>
                </div>
                <input type="text" class="form-control" placeholder="Pessoa Jurídica" disabled />
              </div>

              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <input
                      type="radio"
                      aria-label="Radio button for following text input"
                      value="F"
                      v-model="item.natureza"
                    />
                  </div>
                </div>
                <input type="text" class="form-control" placeholder="Pessoa Física" disabled />
              </div>

              <div class="row mt-3">
                <div class="col col-12" :class="setup ? '' : 'col-md-8'">
                  <az-input
                    :label="item.natureza == 'J' ? 'Nome Fantasia' : 'Nome da Clínica'"
                    :validate="validate"
                    v-model="item.st_nome_fantasia"
                    required
                  />
                </div>
                <div class="col col-12 col-md-4" v-if="!setup">
                  <az-input
                    label="Nome para SMS"
                    :validate="validate"
                    v-model="item.st_nome_sms"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col col-12 col-md-6">
            <div v-if="item.id_unidade" class="d-flex justify-content-end">
              <az-single-image-loader
                :single="true"
                service="unidades"
                :arquivo="item.logo"
                :parms="{ model_type: 'unidade', model_id: item.id_unidade, public: true }"
              ></az-single-image-loader>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-12 col-md-6" v-if="item.natureza == 'J'">
            <az-input
              label="Razão Social"
              :validate="validate"
              v-model="item.st_razao_social"
              required
            />
          </div>
          <div class="col col-12 col-md-6">
            <az-input
              type="email"
              label="e-mail da unidade"
              :validate="validate"
              v-model="item.st_email" />
          </div>
        </div>

        <div class="row">
          <div class="col col-12 col-md-6">
            <az-input
              label="CPF"
              type="cpf"
              :validate="validate"
              v-model="item.st_cpf"
              required
              v-show="item.natureza == 'F'"
            />
            <az-input
              label="CNPJ"
              type="cnpj"
              :validate="validate"
              v-model="item.st_cnpj"
              required
              v-show="item.natureza == 'J'"
            />
          </div>
          <div class="col col-12 col-md-6">
            <az-input
              label="CNES"
              type="cnes"
              :validate="validate"
              v-model="item.st_cnes"
            />
          </div>
        </div>

        <az-sub-title class="mt-3" title="Endereço" />
        <cadastro-endereco v-model="item.endereco" :validate="validate" :map_link="true" />

        <az-sub-title class="mt-3" title="Telefones" />
        <cadastro-telefones v-model="item.telefone_unidades" :validate="validate" />
      </div>

      <!-- Dados do Representante -->

      <div class="card-header">
        <span class="lead text-primary">Dados do Representante</span>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col col-12 col-md-4">
            <az-input
              label="Nome"
              :validate="validate"
              v-model="item.st_nome_representante"
              required
              :rules="['nome']"
            />
          </div>
          <div class="col col-12 col-md-4">
            <az-input
              label="Telefone"
              :validate="validate"
              v-model="item.st_telefone_representante"
              required
              type="fone"
            />
          </div>
          <div class="col col-12 col-md-4">
            <az-input
              label="CPF"
              type="cpf"
              :validate="validate"
              v-model="item.st_cpf"
            />
          </div>
        </div>
      </div>

      <!-- Especialidades -->

      <div class="card-header">
        <span class="lead text-primary">Especialidades</span>
      </div>

      <div class="card-body">
        <div class="row" v-for="(esp, ie) in lista_especialidades" :key="ie">
          <div class="col col-12 col-md-6">
            <az-input
              :validate="validate"
              v-model="esp.id_especialidade"
              required
              type="select"
              optionsMode="aql"
              optionsData="id_especialidade"
              :optionsSync="false"
              service="especialidades.index"
              icon="fas fa-trash-alt"
              :buttonIcon="true"
              buttonText="fas fa-minus"
              buttonColor="outline-danger"
              @clickButton="excluirEspecialidade(esp)"
            />
          </div>
          <div class="col col-12 col-md-6">
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <input
                    type="checkbox"
                    aria-label="Radio button for following text input"
                    value="1"
                    v-model="esp.fl_nao_encerrar_atendimento"
                  />
                </div>
              </div>
              <input
                type="text"
                class="form-control"
                placeholder="Não encerrar o atendimento atual ao chamar o próximo"
                disabled
              />
            </div>
          </div>
        </div>

        <button
          type="button"
          class="btn btn-outline-primary btn-sm mt-2"
          @click="incluirEspecialidade()"
        >
          <i class="fas fa-plus mr-2"></i>
          Incluir Especialidade
        </button>
      </div>

      <!-- Configurações -->

      <div class="card-header">
        <span class="lead text-primary">Configurações</span>
      </div>

      <div class="card-body">

        <template v-if="!setup">
          <az-sub-title title="Aparência" />
          <div class="row">
            <div class="col col-12 col-md-4">
              <az-input 
                type="checkbox-group" 
                label="Definir cor da barra superior"
                v-model="item.tem_cor"
                @click="item.st_cor_barra = null" />
            </div>
            <div class="col col-12 col-md-2">
              <az-input 
                v-if="item.tem_cor"
                type="color" 
                placeholder="Padrão..."
                v-model="item.st_cor_barra" />
            </div>
            <div class="col col-12 col-md-6">
                <div class="small text-muted">
                    Fundo da Tela de Login
                </div>
                <div v-if="item.id_unidade" class="d-flex justify-content-end">
                    <az-single-image-loader
                        v-if="!setup"
                        titulo="Fundo da Tela de Login"
                        chave="ass"
                        :single="true"
                        :arquivo="item.imagem_assinatura"
                        :parms="{ 
                        model_type: 'unidade', 
                        model_id: item.id_unidade, 
                        tipo_especial: 'ass',
                        public: true
                        }"
                        service="unidades">
                    </az-single-image-loader>
                </div>
            </div>
          </div>

          <div class="row">
            <div class="col col-12 col-md-6">
            </div>
            <div class="col col-12 col-md-6">
                <div class="small text-muted">
                    Fundo da Tela de Login do Portal
                </div>
                <div v-if="item.id_unidade" class="d-flex justify-content-end">
                    <az-single-image-loader
                        v-if="!setup"
                        titulo="Fundo da Tela de Login (Portal)"
                        chave="portal"
                        :single="true"
                        :arquivo="item.imagem_portal"
                        :parms="{ 
                            model_type: 'unidade', 
                            model_id: item.id_unidade, 
                            tipo_especial: 'portal',
                            public: true
                        }"
                        service="unidades">
                    </az-single-image-loader>
                </div>
            </div>
          </div>
        </template>

        <az-sub-title title="Impressões" />
        <div class="row">
          <div class="col col-12 col-md-6">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <input
                    type="checkbox"
                    aria-label="Radio button for following text input"
                    v-model="item.fl_timbrado"
                  />
                </div>
              </div>
              <input
                type="text"
                class="form-control"
                placeholder="Utiliza impressões em papel timbrado"
                disabled
              />
            </div>
          </div>
        </div>

        <!-- Timbrado A4 -->
        <div class="row">
          <div class="col col-12 col-md-3">
            <az-input
              label="A4 Margem Superior (cm)"
              type="number"
              v-model="item.in_margem_superior_a4"
            />
          </div>
          <div class="col col-12 col-md-3">
            <az-input
              label="A4 Margem Inferior (cm)"
              type="number"
              v-model="item.in_margem_inferior_a4"
            />
          </div>
          <div class="col col-12 col-md-3">
            <az-input
              label="A4 Margem Esquerda (cm)"
              type="number"
              v-model="item.in_margem_esquerda_a4"
            />
          </div>
          <div class="col col-12 col-md-3">
            <az-input
              label="A4 Margem Direita (cm)"
              type="number"
              v-model="item.in_margem_direita_a4"
            />
          </div>
        </div>

        <!-- Timbrado A5 -->
        <div class="row">
          <div class="col col-12 col-md-3">
            <az-input
              label="A5 Margem Superior (cm)"
              type="number"
              v-model="item.in_margem_superior_a5"
            />
          </div>
          <div class="col col-12 col-md-3">
            <az-input
              label="A5 Margem Inferior (cm)"
              type="number"
              v-model="item.in_margem_inferior_a5"
            />
          </div>
          <div class="col col-12 col-md-3">
            <az-input
              label="A5 Margem Esquerda (cm)"
              type="number"
              v-model="item.in_margem_esquerda_a5"
            />
          </div>
          <div class="col col-12 col-md-3">
            <az-input
              label="A5 Margem Direita (cm)"
              type="number"
              v-model="item.in_margem_direita_a5"
            />
          </div>
        </div>
      </div>
    </div>

    <pre v-if="1 == 0">{{ item }}</pre>

    <nav class="navbar fixed-bottom navbar-light bg-light" v-if="item">
      <div>
        <az-submit class="mr-2" @click="atualizar ()">Atualizar</az-submit>
        <button
          class="btn btn-secondary mr-2"
          @click="dados.length > 1 ? ( item = null ) : ( item = dados[0] )"
          v-if="dados.length > 1 || !item.id_unidade"
        >Fechar</button>
        <button class="btn btn-outline-secondary mr-2" @click="$util.logAudit('unidade', item.id_unidade)"
          v-if="item.id_unidade && !setup">
          Log
        </button>
      </div>

      <div v-if="1 == 0">
        <button class="btn btn-outline-success" v-if="dados && dados.length == 1" @click="incluir()">
          Incluir Unidade
        </button>
      </div>
    </nav>
  </div>
</template>

<script>
import ConfigMainTitle from "../shared/ConfigMainTitle.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubTitle from "../../util/AzSubTitle.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import CadastroEndereco from "../../shared/CadastroEndereco.vue";
import CadastroTelefones from "../../shared/CadastroTelefones.vue";
import AzEmptyState from "../../util/AzEmptyState.vue";
import AzSingleImageLoader from "../../util/AzSingleImageLoader.vue";

export default {
  data() {
    return {
      dados: null,
      validate: false,
      item: null, 
    };
  },

  props: ['setup'],

  components: {
    AzInput,
    AzSubTitle,
    ConfigMainTitle,
    CadastroEndereco,
    CadastroTelefones,
    AzSubmit,
    AzEmptyState,
    AzSingleImageLoader
  },

  computed: {
    lista: function () { 
      return this.dados;
    },

    lista_especialidades: function() {
      if ( !this.item || !this.item.especialidade_unidades ) 
        return [];

      return this.item.especialidade_unidades.filter(it => {
        return !it.excluido;
      });
    }
  },

  methods: {
    incluir () { 

      this.item = { 
        id_unidade: null,
        natureza: 'J',
        telefone_unidades: [], 
        especialidade_unidades: [],
        endereco: {
          cidade: {}
        },
      };

      window.scroll(0,0);

    },

    editar (item) { 

      this.item = null;

      this.$nextTick(() => { 
          if (!item.endereco) {
            item.endereco = {};
          }

          this.item = item;
      });

    },

    load() {
      this.$util.load(this, { 
        service: 'unidades',
        parms: { 
          cadastro: true, 
        },
        loadTo: (lista) => { 
          this.dados = lista.map(item => { 
            if (!item.endereco) {
              item.endereco = {};
            }

            return item;
          });

          if ( this.dados.length == 1 )
            this.editar (this.dados[0]);
        }
      });

      /*

      this.$store.commit("loading", true);

      let query = {
        q: [
          {
            name: "unidades.index",
            id: "unidade",
            parms: {
              id: 1
            }
          }
        ]
      };

      this.axios
        .post("/aql", query)
        .then(res => {
          if (res.data.unidade.status == 200) {
            this.dados = res.data.unidade.data;

            if (!this.dados.endereco) {
              this.dados.endereco = {};
            }

            // Atualiza a Unidade no $store
            this.$store.commit("setUnidade", null);
            this.$store.commit("setUnidade", res.data.unidade.data);
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });

      */
    },

    excluirEspecialidade(esp) {
      esp.excluido = true;
    },

    incluirEspecialidade() {
      this.item.especialidade_unidades.push({
        id_especialidade_unidade: null,
        especialidade: null,
        fl_nao_encerrar_atendimento: "0",
        excluido: false
      });
    },

    atualizar() {
      this.$util.atualizar (this, { 
        service: 'unidades', 
        dados: this.item, 
        toast: true, 
        reload: true,
        callback: item => { 
          this.editar(item);
        }
      });

    }
  },

  mounted() {
    if ( !this.setup ) { 
      this.$store.commit("setBreadcrumb", [
        { name: "Configurações", path: "/cadastros" },
        { name: "Clínica", path: "/config/clinica" }
      ]);
    }

    this.load();
  }
};
</script>

<style scoped>
.az-anime-from-right {
  animation: az-from-right 500ms;
}

@keyframes az-from-right {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0px) ease-in-out;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>